var map = {
	"./Calzamaglia_A191_CLASSIC.json": 381,
	"./Calzamaglia_A391_ELITE.json": 382,
	"./Pantalone_A222_TEAM.json": 383,
	"./Pantalone_A232_TEAM_3.4.json": 384,
	"./Pantalone_A283_TEAM_INV_L.json": 385,
	"./Salopette_A121_CLASSIC.json": 386,
	"./Salopette_A221_TEAM.json": 387,
	"./Salopette_A231_3.4.json": 388,
	"./Salopette_A281_INVERNALE.json": 389,
	"./Salopette_A321_ELITE.json": 390,
	"./Salopette_A421_PERFORMANCE.json": 391,
	"./Salopette_A422_PREMIUM.json": 392,
	"./Salopette_A481_PERFORMANCE_INV.json": 393,
	"./Salopette_AX122_SPRINT.json": 394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 380;